import * as Util from "../Utils/Util";
import DomFactory from "../Utils/DomFactory";
import Events from "../Utils/Events";
import ButtonMarker from "../Utils/ButtonMarker";
import ProductState from "./ProductState";

export default class ProductButton {
  private readonly element: HTMLElement;
  private readonly code: string;

  public constructor(element: HTMLElement) {
    this.element = element;
    this.code = Util.getData(element, "productCode");
    element.addEventListener("click", () => this.send());
    Events.on("product-state-change", (state: ProductState) =>
      ButtonMarker.mark(element, state.product.code == this.code)
    );
  }

  public send(): void {
    Events.fire("product-changed", this.code);
  }

  public static Factory: DomFactory<ProductButton> = (e) => new ProductButton(e);
}
